export { default } from "./useWritePromptResponsePost";
